exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-item[data-v-43e1da30]{flex-shrink:0;padding:0 1em;height:100%;font-family:PingFangSC-Regular;display:flex;align-items:center;cursor:pointer}.tabs-item.active[data-v-43e1da30]{color:#4a90e2}.tabs-item.disabled[data-v-43e1da30]{color:gray;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43e1da30","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/tabs/bf-tabs-item/bf-tabs-item.vue
// module id = 82
// module chunks = 0